export default __webpack_public_path__ + "static/9dd37b4c-8cea-425d-b7bd-c91933b3f34e-6e884f63f33d0160fbd1c2b0cf9803ca.woff";